const isDesktop = window.matchMedia("(min-width: 768px)").matches;
const prefersReducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

const handleUIInteractions = () => {
  const contactTriggers = document.querySelectorAll("[data-contact-trigger]");
  const contactFormContainer = document.getElementById(
    "contact-form-container",
  );
  const closeFormButton = document.getElementById("close-form");
  const openNavButton = document.querySelector(".open-nav");
  const menuContainer = document.querySelector(".menu-container");
  const closeNavButton = document.querySelector(".close-nav");
  const html = document.documentElement;
  const form = document.querySelector("#contact-form");
  const thanks = document.querySelector("#contact-form__thanks");
  const contactTitle = document.querySelector("#contact-title");
  let lastFocusedElement = null;

  const resetForm = () => {
    if (!form) return;

    form.reset();
    form.style.display = "";
    form.dispatchEvent(new CustomEvent("bbdo:reset-files"));

    if (thanks) thanks.style.display = "none";
    if (contactTitle) contactTitle.style.display = "";

    const defaultState = document.getElementById("defaultState");
    const activeState = document.getElementById("activeState");
    const uploadedFiles = document.querySelectorAll(".input-dd-files__file");

    if (defaultState && activeState) {
      defaultState.style.display = "flex";
      activeState.style.display = "none";
    }

    uploadedFiles.forEach((file) => file.remove());

    const errorMessages = form.querySelectorAll(".just-validate-error-label");
    errorMessages.forEach((error) => error.remove());

    form.querySelectorAll("[data-step]").forEach((step) => {
      step.style.visibility = "hidden";
    });

    const submitButton = form.querySelector(".submit-button");
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.classList.remove("button-disabled");
    }
  };

  const closeMenu = (restoreFocus = true) => {
    if (!menuContainer) return;

    menuContainer.classList.remove("open");
    openNavButton?.setAttribute("aria-expanded", "false");
    html.style.overflow = "";
    if (restoreFocus) openNavButton?.focus();
  };

  const openForm = (trigger) => {
    if (!contactFormContainer || !closeFormButton) return;

    lastFocusedElement = trigger || document.activeElement;
    closeMenu(false);
    contactFormContainer.classList.remove("open");
    gsap.killTweensOf(contactFormContainer);
    gsap.set(contactFormContainer, {
      visibility: "visible",
      pointerEvents: "auto",
    });
    contactFormContainer.setAttribute("aria-hidden", "false");
    contactFormContainer.inert = false;
    gsap.to(contactFormContainer, {
      duration: prefersReducedMotion ? 0 : 0.4,
      width: isDesktop ? "70vw" : "100vw",
      ease: "power1.in",
    });
    html.style.overflow = "hidden";
    closeFormButton.focus();
  };

  const closeForm = () => {
    if (!contactFormContainer) return;

    contactFormContainer.classList.remove("open");
    contactFormContainer.setAttribute("aria-hidden", "true");
    contactFormContainer.inert = true;
    gsap.killTweensOf(contactFormContainer);
    gsap.to(contactFormContainer, {
      duration: prefersReducedMotion ? 0 : 0.4,
      width: 0,
      ease: "power1.out",
      onComplete: () => {
        gsap.set(contactFormContainer, {
          visibility: "hidden",
          pointerEvents: "none",
        });
      },
    });
    html.style.overflow = "";
    resetForm();

    if (lastFocusedElement instanceof HTMLElement) {
      const focusTarget = menuContainer?.contains(lastFocusedElement)
        ? openNavButton
        : lastFocusedElement;
      focusTarget?.focus();
    }
  };

  contactTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      openForm(trigger);
    });
  });

  closeFormButton?.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    closeForm();
  });

  if (openNavButton && menuContainer && closeNavButton) {
    openNavButton.addEventListener("click", () => {
      menuContainer.classList.add("open");
      openNavButton.setAttribute("aria-expanded", "true");
      html.style.overflow = "hidden";
      closeNavButton.focus();
    });

    closeNavButton.addEventListener("click", () => {
      closeMenu();
    });
  }

  form?.querySelector(".cancel-button")?.addEventListener("click", (event) => {
    event.preventDefault();
    closeForm();
  });

  document.addEventListener(
    "click",
    (event) => {
      if (
        contactFormContainer?.getAttribute("aria-hidden") === "false" &&
        event.target instanceof Element &&
        !contactFormContainer.contains(event.target) &&
        !event.target.closest("[data-contact-trigger]")
      ) {
        event.preventDefault();
        event.stopPropagation();
        closeForm();
      }
    },
    true,
  );

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;

    if (contactFormContainer?.getAttribute("aria-hidden") === "false") {
      closeForm();
    } else if (menuContainer?.classList.contains("open")) {
      closeMenu();
    }
  });
};

export default handleUIInteractions;
